import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'rosie-collapsible-section',
  templateUrl: './collapsible-section.component.html',
  styleUrls: ['./collapsible-section.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class CollapsibleSectionComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() expanded = false;
  @Input() dataHook = 'collapsible-section';
  @Output() toggled = new EventEmitter<boolean>();

  toggle(): void {
    this.expanded = !this.expanded;
    this.toggled.emit(this.expanded);
  }
}
